import { Flex } from '@chakra-ui/react'
import React from 'react'

import { H1, H2, StandardText } from '../Typography/Typography'

/**
 * Client-side counterpart of the standalone `maintenance-page` package that
 * nginx serves. The copy is deliberately identical; the illustration is not
 * carried over because that asset lives in the other package and the apps here
 * render in Chakra rather than the standalone page's styled-components theme.
 *
 * Rendered in place of the whole app, above authentication, so it shows even
 * when the APIs it would otherwise talk to are down for the same maintenance.
 */
export const Maintenance = () => (
  <Flex
    align="center"
    as="main"
    bg="neutral.20"
    data-testid="maintenance-page"
    direction="column"
    flex="1"
    justify="center"
    minH="100%"
    px={5}
    py={20}
  >
    <H1 center>Application maintenance</H1>
    <H2 center>We will be back soon!</H2>
    <StandardText center>
      Sorry for the inconvenience but we are performing some maintenance at the
      moment.
    </StandardText>
    <StandardText center>We will be back online shortly.</StandardText>
  </Flex>
)
